import React from 'react';
import { Button, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DuplicateDocument from './DuplicateDocument';
import styles from './DuplicateAnalyzer.module.css';

const DuplicateAnalyzer = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.headerRow}>
          <Button 
            className={styles.backButton}
            onClick={() => window.history.back()}
            startIcon={<ArrowBackIcon />}
          >
            Back
          </Button>
          <h1 className={styles.pageTitle}>Hamming Distance Analyzer</h1>
        </div>
        <p className={styles.pageSubtitle}>Check for duplicate documents using charikarLSH hash comparison</p>
      </div>

      <Paper className={styles.contentPaper}>
        <DuplicateDocument />
      </Paper>
    </div>
  );
};

DuplicateAnalyzer.propTypes = {};

DuplicateAnalyzer.defaultProps = {};

export default DuplicateAnalyzer;
